module.exports = __webpack_public_path__ + "img/logo-new.df548e65.svg";